
import { Card, CardContent } from "@/components/ui/card";
import { PromptSectionProps } from "./types";
import { Button } from "@/components/ui/button";
import { PencilLine, Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";

interface EnhancedPromptSectionProps extends PromptSectionProps {
  onSelect?: (title: string) => void;
  examples?: string[];
}

export const PromptSection = ({ 
  title, 
  description, 
  onSelect,
  examples = []
}: EnhancedPromptSectionProps) => {
  return (
    <Card className="hover:border-primary/30 transition-colors">
      <CardContent className="pt-6">
        <div className="flex justify-between items-start mb-2">
          <h3 className="font-medium flex items-center">
            {title}
            {examples.length > 0 && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button variant="ghost" size="icon" className="h-5 w-5 ml-1">
                      <Info className="h-4 w-4 text-muted-foreground" />
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent className="max-w-80">
                    <div className="space-y-2">
                      <p className="font-medium">Examples:</p>
                      <ul className="list-disc pl-4 text-sm space-y-1">
                        {examples.map((example, i) => (
                          <li key={i}>{example}</li>
                        ))}
                      </ul>
                    </div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </h3>
          {onSelect && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="h-7 gap-1 text-xs"
              onClick={() => onSelect(title)}
            >
              <PencilLine className="h-3 w-3" />
              Edit
            </Button>
          )}
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          {description}
        </p>
      </CardContent>
    </Card>
  );
};
